import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { globalStyles } from '../style/gstheme';
import SubscriptionCard from './SubscriptionCard';
import Errored from '../Errored';

const styles = () => {
  return Object.assign({
    subscribed: {
      float: 'left',
      margin: 20,
      padding: 20,
      width: 300,
      '&:hover': {
        cursor: 'pointer',
        backgroundColor: '#cccccc'
      },
    }
  }, globalStyles);
};

class SubscriptionCardContainer extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isErrored: false,
      cancelled: false
    };
  }

  cancelSubscription = () => {
    try {
      const Paddle = window.Paddle;
      Paddle.Checkout.open({
        override: this.props.cancelURL,
        successCallback: () => this.props.onCancel(this.props.subscriptionIRI)
      });
    }
    catch (e) {
      this.setState({ isErrored: { message: "We cannot connect to Paddle at the moment. Please try again later." } });
    }
  };

  updateSubscription = () => {
    try {
      const Paddle = window.Paddle;
      Paddle.Checkout.open({
        override: this.props.updateURL
      });
    }
    catch (e) {
      this.setState({ isErrored: { message: "We cannot connect to Paddle at the moment. Please try again later." } });
    }
  };

  render() {

    const { isErrored } = this.state;
    const { subscriptionIRI, active, approved, subscriptionType, cancelled, cancelURL,
      selectSubscription, name, subscriptionPackage, maxUsers, expirationDate } = this.props;

    if (isErrored) return <Errored data={isErrored} />;

    return (
      <React.Fragment>
        <SubscriptionCard
          cancelled={cancelled}
          cancellable={cancelURL}
          subscriptionType={subscriptionType}
          expirationDate={expirationDate}
          subscriptionIRI={subscriptionIRI}
          cancelSubscription={this.cancelSubscription}
          updateSubscription={this.updateSubscription}
          name={name}
          approved={approved}
          subscriptionPackage={subscriptionPackage}
          maxUsers={maxUsers}
          active={active}
          selectSubscription={selectSubscription}
        />
      </React.Fragment>
    );
  }
}

SubscriptionCardContainer.defaultProps = {
  active: false,
  approved: false,
  cancelled: false
};

SubscriptionCardContainer.propTypes = {
  classes: PropTypes.object,
  onCancel: PropTypes.func,
  cancelled: PropTypes.bool,
  approved: PropTypes.bool,
  expirationDate: PropTypes.number,
  subscriptionType: PropTypes.string.isRequired,
  subscriptionIRI: PropTypes.string.isRequired,
  cancelURL: PropTypes.string,
  updateURL: PropTypes.string,
  active: PropTypes.bool,
  selectSubscription: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  subscriptionPackage: PropTypes.string.isRequired,
  maxUsers: PropTypes.number.isRequired
};

export default withStyles(styles)(SubscriptionCardContainer);